// The console's agents tab (spec 15 §4 S23; D-645), English. Spread into
// `adminEn` under one key, so the area stays one namespace and the parity
// gate covers these keys with the rest. The other five locales live beside
// this file as admin-agents.<locale>.ts.
//
// Counted nouns are never agreed with their number: the count follows a
// colon (D-030). No string runs past 25 words (D-425): a longer thought is
// two keys the screen joins with `joinSentences`.

export const adminAgentsEn = {
  agentModels: {
    tab: "Agents",
    title: "Agents",
    lead: "Each agent and the model profile it runs on.",
    leadRecorded: "A recorded profile replays stored answers and calls no model.",
    leadLive: "A live profile calls a model on Amazon Bedrock and is paid for by the token.",
    sandboxNote:
      "Your sandbox scope reaches sandbox tenants only, so this tenant's agents are read-only for you.",
    viewerNote: "Platform admins switch an agent's model profile. You can read it here.",
    loading: "Loading agents…",
    loadFailed: "Couldn't load this tenant's agents.",
    emptyTitle: "No agents yet",
    emptyBody:
      "Agents are set up within a minute of the tenant going active, wherever a model profile is configured.",
    colAgent: "Agent",
    colStatus: "Status",
    colProfile: "Model profile",
    colBudget: "Daily token budget",
    colAction: "Action",
    status: {
      enabled: "On",
      paused: "Paused",
      disabled: "Off",
    },
    adapter: {
      bedrock: "Live model (Amazon Bedrock)",
      recorded: "Recorded answers, no model",
      other: "Not offered here",
    },
    availability: {
      ok: "Model found",
      unchecked: "Not checked yet",
      unavailable: "Unavailable: {{reason}}",
    },
    profilesTitle: "Profiles in this environment",
    defaultProfile: "New agents start on: {{name}}",
    noDefault: "No profile is configured, so no agent can run here.",
    noBedrockTitle: "No live model in this environment",
    noBedrockBody:
      "Its servers hold no Bedrock grant, so agents here can only replay recorded answers.",
    noBedrockFix: "Live drafting needs an environment whose agent settings name a Bedrock profile.",
    price: "Input: {{input}} per million tokens · output: {{output}} per million tokens",
    noPrice: "No charge",
    change: "Change",
    noTargets: "No other profile can be chosen.",
    dialogTitle: "Change the model profile",
    dialogLead: "{{agent}} runs on {{current}} now.",
    choose: "New profile",
    costTitle: "This spends money",
    costRuns: "On {{profile}} every run calls the model and is billed by the token.",
    costBudget:
      "This agent's daily token budget: {{budget}}. A full day costs about {{ceiling}} at the output price.",
    costAccount: "The spend counts against the account's monthly Bedrock budget.",
    freeRuns:
      "On {{profile}} the agent replays recorded answers, calls no model and costs nothing.",
    freeGap: "A message it has no recording for is not drafted.",
    effect: "The change applies to every run that has not called the model yet.",
    cancel: "Cancel",
    confirm: "Switch to {{profile}}",
    saving: "Switching…",
    switched: "{{agent}} now runs on {{profile}}.",
    refusal: {
      conflict: "Someone changed this agent first. Its current profile is shown again.",
      noBedrock: "This environment has no Bedrock profile, so it cannot run a live model.",
      unknownProfile: "This environment does not have that profile. Nothing was changed.",
      notOffered: "That profile is a test fixture the console does not set.",
      unavailable: "The model behind that profile is unavailable right now. Nothing was changed.",
      forbidden: "Your role can't change this agent.",
      gone: "This agent no longer exists. The list is read again.",
      failed: "The change didn't go through. Try again.",
    },
  },
};
